require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-post.json") })
        }
      }, "path---news-post");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-post!./.cache/json/news-post.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-post!./.cache/json/news-post.json
// module chunks = 231608221292675